import { render, staticRenderFns } from "./ed-text.vue?vue&type=template&id=8298bcda&scoped=true&"
import script from "./ed-text.ts?vue&type=script&lang=js&"
export * from "./ed-text.ts?vue&type=script&lang=js&"
import style0 from "./ed-text.scss?vue&type=style&index=0&id=8298bcda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8298bcda",
  null
  
)

export default component.exports